module.exports = __webpack_public_path__ + "img/guanwang_icon_jiantou_blue.0bed314e.svg";